var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"Units",attrs:{"id":"buildings"}},_vm._l((_vm.topUnits),function(unit,index){return _c('UnitPage',{key:unit.unitID,attrs:{"index":index,"isLoading":_vm.isLoading,"unit":unit}})}),1)}
var staticRenderFns = []

export { render, staticRenderFns }